import { render, staticRenderFns } from "./question-multiple.vue?vue&type=template&id=1a6d0a6b&scoped=true&"
import script from "./question-multiple.vue?vue&type=script&lang=js&"
export * from "./question-multiple.vue?vue&type=script&lang=js&"
import style0 from "./question-multiple.vue?vue&type=style&index=0&id=1a6d0a6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6d0a6b",
  null
  
)

export default component.exports